import { Component} from '@angular/core';
import { Machine} from "../../models/machine";
import { MachineOutage } from "../../models/machine-outage";
import { Report } from "../../models/report";
import { VendInfo } from "../../models/vend-info";
import { HubModule } from "../../models/hub-module";
import { PrizeSlot } from "../../models/prize-slot";
import { ReportsService } from "../../services/reports.service";
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import {UserService} from "../../services/user.service";
import * as jsPDF from 'jspdf';
import * as moment from 'moment/moment';
import * as html2canvas from 'html2canvas';
import * as _ from "lodash";

@Component({
    moduleId: module.id,
    selector: 'reports',
    templateUrl: 'reports.component.html',
    styleUrls: ['reports.component.scss']
})

export class ReportsComponent{

    public stateOuter = 'machine'; //machine, fleet
    public stateInner = 'stats'; //stats, history
    public subscreen = 'select'; //select, display
    public machinesToSelect: any[];
    public machinesSelected: Machine[];
    public reports: Report;
    public machineIds: string[];
    public dateFrom: Date;
    public dateFromAsDate: any;
    public dateToAsDate: any;
    public dateTo: Date;
    public datePickerFromOpen = false;
    public datePickerToOpen = false;
    public activeChip = 0;
    public currentVendTotal: number = 0;
    public currentVendPrizeCostTotal = 0;
    public modalHide = [true, true, true, true, true];
    public now: Date;
    public sendingEmail: boolean = false;
    public printing: boolean = false;
    public showAll: boolean = false;
    public showGenerate: boolean = true;
    public reportPdfUrl: string = "";
    private datePickerSettings;

    // private myDatePickerOptionsFrom = {
    //     todayBtnTxt: 'Today',
    //     dateFormat: 'yyyy-mm-dd',
    //     firstDayOfWeek: 'su',
    //     sunHighlight: true,
    //     height: '30px',
    //     width: '100%',
    //     inline: false,
    //     selectionTxtFontSize: '14px',
    //     showClearDateBtn: false
    // };

    // private myDatePickerOptionsTo = {
    //     todayBtnTxt: 'Today',
    //     dateFormat: 'yyyy-mm-dd',
    //     firstDayOfWeek: 'su',
    //     sunHighlight: true,
    //     height: '30px',
    //     width: '100%',
    //     inline: false,
    //     selectionTxtFontSize: '14px',
    //     alignSelectorRight: true,
    //     showClearDateBtn: false
    // };

    constructor(
        private reportsService: ReportsService,
        private toastr: ToastsManager,
        private userservice: UserService
    ) {
        this.machineIds = [];
        this.machinesSelected = [];
        this.now = new Date();
        let fromMoment = moment(this.now).startOf('date');
        let toMoment = moment(this.now).endOf('date');
        this.dateFrom = fromMoment.toDate();
console.log('dateFrom is ', this.dateFrom);
        this.dateTo   = toMoment.toDate();
        this.datePickerSettings = {
            bigBanner: false,
            timePicker: false,
            format: 'MMM dd, yyyy',
            defaultOpen: false,
            closeOnSelect: true
        };
    };

    onMachineGet(machines: any[]) {
        this.machinesToSelect = machines;
    };

    getMachineForId(id: string): Machine {
        if (this.machinesSelected) {
            for (let m of this.machinesSelected) {
                if (m.id === id) return m;
            }
        }
        return null;
    }

    generateReport(): void {
        this.showGenerate = false;
        for(let m of this.machinesToSelect){
            if(m.selected){
                this.machinesSelected.push(m.machine);
                this.machineIds.push(m.machine.id);
            }
        }

        if (this.machineIds.length === 0) {
            this.toastr.error("Please select at least one machine before generating a report.");
            this.showGenerate = true;
            return;
        }

        let self = this;

        if (this.dateFrom && this.dateTo) {
            let from = moment(this.dateFrom).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss.SSS');
            let to = moment(this.dateTo).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss.SSS');

            this.reportPdfUrl = this.reportsService.getReportDownloadUrl(from, to, this.machineIds.join(','));

            self.reportsService.getBaseReports(from, to, this.machineIds.join(',')).then(reports => {
                self.subscreen='display';
                self.reports = reports;
                self.activeChip = 0;
            });
        } else {
            this.showGenerate = true;
            this.toastr.error("Please select a to and from date for the report");
        }
    };

    generatePdf() {
        this.toastr.success("Your report will download when finished", "Retrieving your data...", {toastLife: 20000});
        var link = document.createElement('a');
        link.href = this.reportPdfUrl;
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    getInventory(info: VendInfo) {
        let selectedMachine = this.machinesSelected[this.activeChip];
        let modules = _.filter(selectedMachine.hubModules, hm => { return hm.type === info.moduleType; });
        for (let module of modules) {
            for (let slot of module.slots) {
                if (slot.name === info.location) {
                    return `${slot.remainingQuantity} of ${slot.maxQuantity} remaining`;
                }
            }
        }
        return '';
    }

    getCurrentVendInfoForSlot(machine: Machine, hubModule: HubModule, slot: PrizeSlot) {
      let vendMachine = _.find(this.reports.currentVends, cv => { return cv.machineId === machine.id });
      let vendSlot = _.find(vendMachine.successes, cv => { return cv.text === slot.name });
      if (vendSlot) {
          return { vends: parseInt(vendSlot.value), prizeCost: Number(vendSlot.value2) };
      }
      return { vends: 0, prizeCost: 0 };
    }

    getCurrentVendValueSinceResetForSlot(machine: Machine, hubModule: HubModule, slot: PrizeSlot) {
      let currentVend = _.find(machine.currentVends, currentVend => {
        if (currentVend.moduleType && hubModule.type) {
            return hubModule.type.toLowerCase() === currentVend.moduleType.toLowerCase()
                        && slot.name === currentVend.location;
        }
        });
      if (currentVend) {
        return parseInt(currentVend.value);
      }
      return 0;
    }

    getLastStatReset(machine: Machine) {
        if (machine.lastStatReset) {
            return moment(machine.lastStatReset).format('MMM d, yyyy HH:mm Z');
        }
        return 'Unknown';
    }

    getMachinesTitle(machines) {
        let title = '';
        for (let m of machines) {
            title += `${m.name}, `;
        }
        title = title.substring(0, title.length - 2);
        return title;
    }

    getReportVendTotal(machine: Machine) {
      return this.currentVendTotal;
    }

    getCurrentVendInfo(machine: Machine) {
        let currentVendInfo = [];
        this.currentVendTotal = 0;
        this.currentVendPrizeCostTotal = 0;
        let self = this;
        _.each(machine.hubModules, hubModule => {
            _.each(hubModule.slots, slot => {
                const slotVendInfo = this.getCurrentVendInfoForSlot(machine, hubModule, slot);
                let vendInfoObj = {
                    moduleType: hubModule.type,
                    slotName: slot.name,
                    slotDesc: _.isEmpty(slot.description) ? '' : slot.description,
                    vendValue: slotVendInfo.vends,
                    prizeCost: slotVendInfo.prizeCost,
                    vendValueSinceReset: this.getCurrentVendValueSinceResetForSlot(machine, hubModule, slot),
                    remainingQty: slot.remainingQuantity,
                    maxQty: slot.maxQuantity
                };
                currentVendInfo.push(vendInfoObj);
                self.currentVendTotal += vendInfoObj.vendValue;
                self.currentVendPrizeCostTotal += vendInfoObj.prizeCost;
            });
        });

        return currentVendInfo;
    }

    getOutageDuration(outage: MachineOutage) {
        let start = moment(outage.outageStartDate);
        let end = moment(outage.outageEndDate); // if undefined, it will use current time.
        return  moment.duration(end.diff(start)).humanize();
    }

    /*email(attachment) {
        let pdfFile: File = attachment.output('blob', {});

        if (pdfFile.size > 1000000) {
            this.toastr.error("The report file size was too big to send in email, use the download instead.");
        } else {
            let formData:FormData = new FormData();
            formData.append('uploadFile', pdfFile, 'emailPdf');
            this.httpService.postImage(`/FileStorage/zymo-prizehub-reports/upload`, formData).then(file => {
            this.userservice.me()
                .then(response => {
                    this.reportsService.sendEmailWithAttachment(this.dateFrom, this.dateTo, this.machineIds.join(','), response.email, file.name)
                        .then(function(results: any){
                            this.toastr.success("Email Sent");
                            this.showAll = false;
                            this.sendingEmail = false;
                            return {}
                        })
                        .catch(function(error: any){
                            this.httpService.handleError(error, "Unable to email Report");
                            this.showAll = false;
                            this.sendingEmail = false;
                        })
                })
            })
        }
    };*/


    print(showAll, modal) {
        let me = this;
        this.showAll = showAll;
        modal.hide();
        setTimeout(() => {
            if (!window.print()) {
                me.showAll = false;
            }
        }, 50);
    };

    openModal(modal) {
        modal.show();
    }

    backToSelect() {
        this.subscreen = 'select';
        this.machinesSelected = [];
        this.machineIds = [];
        this.showGenerate = true;
    };
}



// WEBPACK FOOTER //
// ./src/app/components/reports/reports.component.ts